/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 **/

export const motorViewQuoteFormInitialValues = {
  personalProtectionPlus: false,
  ncdProtection: false,
  additionalBenefitsPlus: false
};
